import React from "react";
import FeaturedSection from "./FeaturedSection";
import AboutEditorialSection from "./sections/AboutEditorialSection";
import SpeakingSection from "./sections/SpeakingSection";
import ConsultingSection from "./sections/ConsultingSection";
import BooksSection from "./sections/BooksSection";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/oiuyhizp_fad0e5ea-1712-413b-9f1d-c05784213e9c.png";

const IMG = {
  studyDesk:  "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=900&q=80",
  archWindow: "https://images.unsplash.com/photo-1564769662533-4f00a87b4056?auto=format&fit=crop&w=900&q=80",
  classroom:  "https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=900&q=80",
};

/* ────────────────────────────────────────────────────────────────────── */
/*  Each section has a bespoke layout. Only the PODCAST section uses the   */
/*  original "Featured Content" motif (matching the user's reference).     */
/* ────────────────────────────────────────────────────────────────────── */

const aboutSection = {
  id: "about",
  eyebrow: "01 — About",
  headlineA: "A life devoted to teaching.",
  headlineB: "A heart shaped by tarbiyah.",
  intro: "",
  viewAllHref: "/about",
};

const podcastSection = {
  id: "podcast",
  eyebrow: "02 — Featured Content",
  headlineA: "Ideas that shape.",
  headlineB: "Conversations that transform.",
  intro:
    "Explore insights on education, mentorship, faith, and personal growth through podcasts, talks, articles, and reflections.",
  viewAllHref: "/podcast",
  viewAllLabel: "Content",
  featured: {
    kind: "podcast",
    title: "Episode 1: Why The Murabbi Podcast?",
    description:
      "A conversation on rethinking education, restoring meaning, and raising a generation rooted in purpose.",
    image: PORTRAIT,
    href: "https://www.youtube.com/watch?v=Fd04JdWLm5Y",
    actionLabel: "Listen Now",
    meta: "4 MIN",
  },
  cards: [
    {
      kind: "youtube",
      title: "“Some Teachers Teach Lessons… Others Teach With Their Heart”",
      image: "https://img.youtube.com/vi/rTcD6w5WQa0/maxresdefault.jpg",
      href: "https://youtube.com/shorts/rTcD6w5WQa0",
      actionLabel: "Watch Now",
    },
    {
      kind: "article",
      title: "Education Is More Than Information",
      image: "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/esxipfuw_ChatGPT%20Image%20May%2023%2C%202026%2C%2010_13_13%20PM%20%282%29.png",
      href: "http://youtube.com/post/UgkxfphxJap5tSukCTWoKWv_PsEHFyiKvdxL?si=EzNrjj15rliPWajG",
      actionLabel: "Read Article",
    },
    {
      kind: "reflection",
      title: "Your Legacy Begins With a Choice",
      image: "https://customer-assets.emergentagent.com/job_hero-design-6/artifacts/q5ci8zh7_ChatGPT%20Image%20May%2023%2C%202026%2C%2010_14_37%20PM.png",
      href: "https://www.linkedin.com/posts/iyareomoruyi_excerpt-from-the-way-of-the-murabbi-your-share-7450260756731973633-ySEg/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACSAJZQBF8Hq1XwqDERzS3O03ONqdWOG7Bc",
      actionLabel: "Read Reflection",
    },
  ],
  quote: {
    lineA: "The goal of education is not to produce more scholars,",
    lineB: "but to nurture better human beings.",
    signature: "Iyare Omoruyi",
    caption: "The Murabbi Framework",
  },
};

const speakingSection = {
  id: "speaking",
  eyebrow: "03 — Speaking",
  headlineA: "On stage. In hearts.",
  headlineB: "Words carried further than rooms.",
  intro:
    "Keynotes, khutbahs and fireside talks for schools, masajid, conferences and corporate teams — delivered with clarity, depth and the warmth of a teacher who still believes in the human soul.",
  viewAllHref: "/speaking",
};

const consultingSection = {
  id: "consulting",
  eyebrow: "04 — Formation & Initiatives",
  headlineA: "Formation Beyond",
  headlineB: "Information.",
  intro:
    "Programs, mentorship, and educational initiatives rooted in the belief that meaningful growth begins with the cultivation of the human being.",
  viewAllHref: "/consulting",
};

const booksSection = {
  id: "books",
  eyebrow: "05 — Books",
  headlineA: "Words that travel",
  headlineB: "further than rooms.",
  intro:
    "Essays, frameworks and forthcoming books on the Murabbi method — practical scholarship for parents, teachers and leaders who want to raise a generation anchored in faith and awake to its calling.",
  viewAllHref: "/books",
};

const SummarySections = () => {
  return (
    <div data-testid="summary-sections">
      <AboutEditorialSection section={aboutSection} />
      <FeaturedSection section={podcastSection} />
      <SpeakingSection section={speakingSection} />
      <ConsultingSection section={consultingSection} />
      <BooksSection section={booksSection} />
    </div>
  );
};

export default SummarySections;
